<div class="flex-container-live-statuses">
    <div *ngIf="jobcard.id && jobcard.partnerID">
        <app-workshop-jobcard-jobcard-timer [jobcard]="jobcard"></app-workshop-jobcard-jobcard-timer>
    </div>
    <div class="sub-flex-container">
      <div class="locked-banner" *ngIf="isLocked && jobcard.id > 0">
        <daz-icon [name]="'lock'" [size]="'16px'" [color]="'#6D6D6D'"></daz-icon>
        <span>{{'bikeshop.workshop.jobcard.locked_banner' | translate}}</span>
      </div>
      <hub-button *ngIf="jobcard.statusID >= 40 && !isLocked"
                  text="{{ 'bikeshop.modal.update_job_card.job_card.reopen_job_card' | translate }}" [disabled]="reopening"
                  [loading]="reopening" [size]="'xl'" [style]="'outline'" (buttonClick)="reopenJobCard()" />
      <hub-button *ngIf="jobcard.statusID >= 40 && jobcard.statusID <= 45 && !jobcard.isFitting"
                  text="{{ 'bikeshop.workshop.jobcard.manage.mark_as_collected' | translate }}" [disabled]="markingCollected"
                  [loading]="markingCollected" [size]="'xl'" [style]="'secondary'" (buttonClick)="markAsCollected()" />
      <hub-button *ngIf="!jobcard.isFitting && !(jobcard.statusID >= 25 && jobcard.statusID != 35)"
                  pTooltip="{{ (jobcard.itemIsHere ? 'bikeshop.general.mark_as_not_here' : 'bikeshop.general.mark_as_here') | translate }}"
                  tooltipPosition="top"
                  [text]="canDeviceHover ? '' : (jobcard.itemIsHere ? 'bikeshop.general.mark_as_not_here' : 'bikeshop.general.mark_as_here') | translate"
                  [style]="jobcard.itemIsHere ? 'outline' : 'secondary'" [size]="'xl'"
                  [icon]="jobcard.itemIsHere ? 'item-here' : 'item-not-here'" (buttonClick)="toggleItemIsHere()">
      </hub-button>

      <div id="statusDropdown" class="custom-dropdown {{getStatusStyle()}}"
           *ngIf="jobActions && jobActions.length > 0 && jobcard.statusID < 40" [ngClass]="{ open: showStatusActions }"
           (click)="toggleStatusDropdown($event)">
        <div class="selected-option">
          <span>{{ getCurrentStatusLabel() }}</span>
          <span class="dropdown-icon" (click)="toggleStatusDropdown($event)">
            <daz-icon *ngIf="!showStatusActions" [size]="'24px'" [color]="'#6D6D6D'"
                      [name]="'chevron-down'"></daz-icon>
            <daz-icon *ngIf="showStatusActions" [size]="'24px'" [color]="'#6D6D6D'"
                      [name]="'chevron-up'"></daz-icon>
          </span>
        </div>
        <ul class="dropdown-menu-options" *ngIf="showStatusActions">
          <li *ngFor="let action of jobActions" (click)="selectStatusOption(action); $event.stopPropagation()"
              [ngStyle]="{'display' : (action.id === 20 && jobcard.statusID === 15 && action.key === 15) || (action.id === 20 && jobcard.statusID > 15 && action.key === 20) || ((action.id !== 20 && action.id !== 40) || (action.id === 40))  ? 'flex' : 'none'}"
              [class.selected]="action.id === jobcard.statusID"
              [class.disabled]="(action.id === 40 && hasMandatoryChecklistItems) || (action.key === 100 && cancelDisabled)"
              pTooltip="{{ action.key === 100 && cancelDisabled ? ('bikeshop.job_actions.reassign_primary_customer' | translate) : '' }}"
              tooltipPosition="left">
            <span class="status-color {{getStatusIndicatorStyle(action.id)}}"></span>
            <span>{{ action.label }}</span>
            <daz-icon *ngIf="action.id === jobcard.statusID" [name]="'check'" [size]="'20px'"
                      [color]="'#EE3158'"></daz-icon>
          </li>
        </ul>
      </div>
      <hub-button [icon]="sendComms ?'send-alt-2' : 'cross'"
                  pTooltip="{{ (sendComms ? 'bikeshop.workshop.jobcard.manage.disable_notify_customer_header' : 'bikeshop.workshop.jobcard.manage.notify_customer_header') | translate }}"
                  tooltipPosition="top" [size]="'xl'" [style]="sendComms ? 'outline' : 'alert'"
                  (buttonClick)="sendComms = !sendComms" />
    </div>
</div>
